import AddIcon from "@mui/icons-material/Add";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import { IconButton, Radio, TableCell, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import EyeIco from "../../../assets/icons/EyeIco";
import Breadcrumbs from "../../../component/Breadcrumbs";
import CommonButton from "../../../component/Button";
import SnackBar from "../../../component/SnackBar";
import { AddToJobPool } from "../../../redux/action/Candidate";
import { JobCandidateSourcing } from "../../../redux/action/Job";
import { CandidateScoring } from "../../../redux/action/QuickMatch";
import { HandleSkeletion } from "../../../utils/constants";
import { CustomDiv } from "../../chat-bot/style";
import {
  CommonGrid2,
  CustomTooltip,
  DotColor,
  ScoreChange,
  StatusChange,
} from "../../common-components/StyledComponents";
import CandidateResult from "../../jobs/candidate-scoring/components/CandidateResult";
import BackArrowIco from "../../../assets/icons/BackArrowIco";
import CandidateProgress from "./components/CandidateResult";
import JobStarOnlyIco from "../../../assets/icons/JobStarOnlyIco";
import JobStarIco from "../../../assets/icons/JobStarIco";

export default function CandidateToJob() {
  const navigate = useNavigate();
  const query = new URLSearchParams(useLocation().search);
  const candidateId = query.get("id");

  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const dispatch = useDispatch();
  const candidateSourcing = useSelector(
    (state) => state.jobs.jobCandidateSourcing
  );
  const processConditionCheck =
    candidateSourcing[candidateId] &&
    candidateSourcing[candidateId].data.length !== 0 &&
    candidateSourcing[candidateId].status !== "process";

  const processConditionCheckInprogress =
    candidateSourcing[candidateId] &&
    candidateSourcing[candidateId].data.length !== 0 &&
    candidateSourcing[candidateId].status === "Inprogress";
  const [checkSelected, setCheckSelected] = useState({
    candidateSelect: [],
    externalSelect: [],
  });

  console.log(
    candidateSourcing,
    "candidateSourcing_data",
    candidateSourcing?.[candidateId]?.status,
    candidateSourcing?.[candidateId]?.status !== "process"
  );

  const [resultData, setResultData] = useState({
    loading: true,
    company_name: "",
    searhLoading: false,
    data: [
      {
        title: "Relevant Active Jobs",
        fontWeight: 700,
        marginTop: "2rem",
        header: [
          { name: "Select", direction: "asc", sort: false },
          { name: "Id", direction: "asc", sort: false },
          { name: "Name", direction: "asc", sort: false },
          { name: "Type", direction: "asc", sort: false },
          { name: "Relevancy", direction: "asc", sort: false },
          { name: "Match Criteria", direction: "asc", sort: false },
          { name: "Status", direction: "asc", sort: false },
          { name: "Action", direction: "asc", sort: false },
          { name: "View", direction: "asc", sort: false },
        ],
        details: "See More",
        data: [],
      },
    ],
  });

  const breadCrumbData = [
    {
      title: "Candidate Hub",
      navigate: `/candidates`,
    },
    {
      title: query.get("name"),
      navigate: `/candidates/candidate-view?view-id=${candidateId}`,
    },
    {
      title: "Match to Active Jobs",
      active: true,
    },
  ];

  const handleFetchCall = async (candidateId, callback) => {
    setResultData((prev) => {
      return {
        ...prev,
        loading: true,
        data: prev.data.map((item, index) => {
          return {
            ...item,
          };
        }),
      };
    });
    try {
      let data = await CandidateScoring(candidateId);
      setResultData((prev) => {
        return {
          ...prev,
          loading: false,
          data:
            prev.data.map((item, index) => {
              return {
                ...prev.data[index],
                data: data?.data?.suggestions,
              };
            }) || [],
        };
      });
      if (callback) {
        callback(data?.data?.suggestions);
      }
    } catch (error) {
      setResultData((prev) => {
        return {
          ...prev,
          loading: false,
          data:
            prev.data.map((item, index) => {
              return {
                ...item,
              };
            }) || [],
        };
      });
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
    }
  };

  useEffect(() => {
    handleFetchCall(candidateId);
    if (processConditionCheckInprogress) {
      setSnackbarState({
        open: true,
        message:
          "A background process is in progress. Please wait a few minutes while it completes.",
        severity: "note",
      });
    }
  }, []);

  const handleViewClick = (row) => {
    if (row.match_order_no === 0) {
      if (row.type === "Job") {
        navigate(`/jobs/jobs-view?id=${row.id}&title=${row.title}&value=1`);
      } else {
        navigate(`/judica/judica-view?id=${row.id}&title=${row.title}&value=1`);
      }
    } else if (row.match_order_no > 3) {
      if (row.type === "Job") {
        navigate(`/jobs/jobs-view?id=${row.id}&title=${row.title}&value=0`);
      } else
        navigate(`/judica/judica-view?id=${row.id}&title=${row.title}&value=0`);
    } else {
      if (row.type === "Job") {
        navigate(
          `/jobs/jobs-view?id=${row.id}&title=${row.title}&value=${
            row.match_order_no + 1
          }&match_id=${row.match_id}`
        );
      } else
        navigate(
          `/judica/judica-view?id=${row.id}&title=${row.title}&value=${
            row.match_order_no + 1
          }&match_id=${row.match_id}`
        );
    }
  };

  const handleCheckRow = (row) => {
    const existing =
      JSON.parse(localStorage.getItem("Candidate Sourcing")) || {};

    setCheckSelected((prev) => {
      const alreadySelected =
        prev.candidateSelect.length > 0 &&
        prev.candidateSelect[0].id === row.id;

      let newSelected = [];

      // --- TOGGLE: unselect if it's already selected ---
      if (!alreadySelected) {
        const { match_criteria_normal, match_criteria_deep, ...safeRow } = row;
        newSelected = [...prev.candidateSelect, safeRow];
        // newSelected = [row];
      }

      const checkData = newSelected.map((item) => ({
        ...item,
        file: {
          progress: 1,
          buffer: 1,
          visible: false,
        },
      }));

      const updated = {
        ...existing,
        [candidateId]: {
          ...existing[candidateId],
          data: checkData,
          status: "process",
        },
      };

      localStorage.setItem("Candidate Sourcing", JSON.stringify(updated));

      dispatch(
        JobCandidateSourcing({
          id: candidateId,
          data: updated[candidateId].data,
          status: updated[candidateId].status,
        })
      );

      return { candidateSelect: newSelected };
    });
  };

  const handleHubTableBodyData = (row) => {
    return (
      <>
        <TableCell>
          <Radio
            color="primary"
            checked={checkSelected.candidateSelect.some(
              (item) => item.id === row.id
            )}
            onChange={() => handleCheckRow(row)}
            disabled={
              processConditionCheckInprogress || row.is_resume_added
              // candidateSourcing[candidateId] &&
              // candidateSourcing[candidateId].data.length !== 0 &&
              // candidateSourcing[candidateId].status === "fail"
              //   ? false
              //   : (candidateSourcing[candidateId] &&
              //       candidateSourcing[candidateId].data.length !== 0 &&
              //       candidateSourcing[candidateId].status !== "process") ||
              //     row.is_resume_added
            }
          />
        </TableCell>
        <TableCell>{row.order_no || "-"}</TableCell>
        <TableCell>{row.title || "-"}</TableCell>
        <TableCell>{row.type || "-"}</TableCell>
        <TableCell>
          <ScoreChange>{row.relevancy_score}%</ScoreChange>
        </TableCell>
         <TableCell>
          <CommonGrid2 display={"flex"} gap={"10px"}>
            {(row.match_criteria_normal &&
              row.match_criteria_normal.map((item) => {
                return (
                  <CustomDiv
                    border="1px solid"
                    padding="4px"
                    borderRadius="5px"
                    fontSize="12px"
                    
                  >
                    <Typography textTransform="capitalize">
                       {item.name}
                    </Typography>
                   
                  </CustomDiv>
                );
              })) ||
              "-"}
          </CommonGrid2>
        </TableCell>
        <TableCell>
          <StatusChange>
            <DotColor
              color={
                row.status === "Active"
                  ? "green"
                  : row.status === "Hold"
                  ? "orange"
                  : "#667085"
              }
            />
            {row.status || "-"}
          </StatusChange>
        </TableCell>
        <TableCell>
          {row.is_resume_added ? (
            <CommonGrid2 display={"flex"} gap={"10px"}>
              <TaskAltIcon sx={{ color: "#17B26A", fontSize: "20px" }} />
              <Typography variant="body2" color="#17B26A">
                Added
              </Typography>
            </CommonGrid2>
          ) : (
            <Typography variant="body2" color="#7F56D9">
              Not Added
            </Typography>
          )}
        </TableCell>

        <TableCell>
          <IconButton onClick={() => handleViewClick(row)}>
            <EyeIco />
          </IconButton>
        </TableCell>
      </>
    );
  };

  const handleCloseValidation = () => {
    setSnackbarState((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const handleDetails = (i, recordIndex) => {
    setResultData((prev) => {
      return {
        ...prev,
        data: prev.data.map((item, index) => {
          if (index === i) {
            return {
              ...prev.data[index],
              details: item.details === "See More" ? "Hide More" : "See More",
            };
          } else {
            return {
              ...prev.data[index],
            };
          }
        }),
      };
    });
  };

  const handleSerchAgain = async () => {
    const existing =
      JSON.parse(localStorage.getItem("Candidate Sourcing")) || {};
    const updated = {
      ...existing,
      [candidateId]: {
        data: [],
        status: "",
      },
    };
    localStorage.setItem("Candidate Sourcing", JSON.stringify(updated));
    dispatch(
      JobCandidateSourcing({
        id: candidateId,
        data: updated[candidateId].data,
        status: "",
      })
    );
    setCheckSelected((prev) => ({
      ...prev,
      candidateSelect: [],
      externalSelect: [],
    }));
    setResultData((prev) => {
      return {
        ...prev,
        searhLoading: true,
      };
    });
    await handleFetchCall(candidateId);
    setResultData((prev) => {
      return {
        ...prev,
        searhLoading: false,
      };
    });
  };

  const handleAddToJob = async () => {
    const existing =
      JSON.parse(localStorage.getItem("Candidate Sourcing")) || {};
    let checkData = checkSelected.candidateSelect.map((item) => {
      return {
        ...item,
        result_title: "Candidate Search Results",
        file: {
          progress: 1,
          buffer: 1,
          visible: false,
        },
      };
    });
    const updated = {
      ...existing,
      [candidateId]: {
        ...existing[candidateId],
        data: checkData,
        status: "Inprogress",
      },
    };

    localStorage.setItem("Candidate Sourcing", JSON.stringify(updated));
    dispatch(
      JobCandidateSourcing({
        id: candidateId,
        data: updated[candidateId].data,
        status: "Inprogress",
      })
    );

    const resumeIds = checkSelected?.candidateSelect?.map((item) => item.id);

    try {
      const payload = {
        job: resumeIds?.[0],
        resumes: [candidateId],
      };

      const response = await AddToJobPool(payload);
      const reader = response.body.getReader();
      const decoder = new TextDecoder("utf-8");
      let buffer = "";

      while (true) {
        const { value, done } = await reader.read();
        if (done) break;
        const chunk = decoder.decode(value, { stream: true });
        buffer += chunk;
        let boundaryIndex;
        while ((boundaryIndex = buffer.indexOf("}\n")) !== -1) {
          const jsonString = buffer.slice(0, boundaryIndex + 1);
          buffer = buffer.slice(boundaryIndex + 1);
          const jsonResponse = JSON.parse(jsonString);
          try {
            await processJsonResponse(jsonResponse, "internal");
          } catch (e) {
            let checkData = existing[candidateId].map((item) => {
              return {
                ...item,
                file: {
                  ...item.file,
                  message: "Error during the request",
                  visible: true,
                },
              };
            });
            const updated = {
              ...existing,
              [candidateId]: {
                ...existing[candidateId],
                data: checkData,
                status: "fail",
              },
            };

            localStorage.setItem("Candidate Sourcing", JSON.stringify(updated));
            dispatch(
              JobCandidateSourcing({
                id: candidateId,
                data: updated[candidateId].data,
                status: "fail",
              })
            );

            setSnackbarState({
              open: true,
              message: "Error parsing JSON",
              severity: "error",
            });
          }
        }
      }

      if (buffer) {
        const jsonResponse = JSON.parse(buffer);
        try {
          await processJsonResponse(jsonResponse, "internal");
        } catch (e) {
          let checkData = existing[candidateId].data.map((item) => {
            return {
              ...item,
              file: {
                ...item.file,
                message: "Error during the request",
                visible: true,
              },
            };
          });
          const updated = {
            ...existing,
            [candidateId]: {
              ...existing[candidateId],
              data: checkData,
              status: "fail",
            },
          };

          localStorage.setItem("Candidate Sourcing", JSON.stringify(updated));
          dispatch(
            JobCandidateSourcing({
              id: candidateId,
              data: updated[candidateId].data,
              status: "fail",
            })
          );
          setSnackbarState({
            open: true,
            message: "Error parsing final JSON chunk",
            severity: "error",
          });
        }
      }
    } catch (error) {
      let checkData = existing[candidateId].data.map((item) => {
        return {
          ...item,
          file: {
            ...item.file,
            message: "Error during the request",
            visible: true,
          },
        };
      });
      const updated = {
        ...existing,
        [candidateId]: {
          ...existing[candidateId],
          data: checkData,
          status: "fail",
        },
      };

      localStorage.setItem("Candidate Sourcing", JSON.stringify(updated));
      dispatch(
        JobCandidateSourcing({
          id: candidateId,
          data: updated[candidateId].data,
          status: "fail",
        })
      );

      setSnackbarState({
        open: true,
        message: "Error during the request",
        severity: "error",
      });
    }
  };

  const processJsonResponse = async (jsonResponse, type) => {
    const { success, data, message, resume_id } = jsonResponse;

    if (Object.keys(data).length === 0) {
      const existing =
        JSON.parse(localStorage.getItem("Candidate Sourcing")) || {};
      let checkData = existing[candidateId].data.map((item) => {
        return {
          ...item,
          file: {
            ...item.file,
            message: message,
            visible: true,
            progress_message: data.progress_message,
          },
        };
      });
      const updated = {
        ...existing,
        [candidateId]: {
          ...existing[candidateId],
          data: checkData,
          status: "fail",
        },
      };

      localStorage.setItem("Candidate Sourcing", JSON.stringify(updated));
      dispatch(
        JobCandidateSourcing({
          id: candidateId,
          data: updated[candidateId].data,
          status: "fail",
        })
      );

      setSnackbarState({
        open: true,
        message: message,
        severity: "error",
      });
    } else if (success && data?.percent !== undefined) {
      const existing =
        JSON.parse(localStorage.getItem("Candidate Sourcing")) || {};
      let checkData = existing[candidateId].data.map((item) => {
        return {
          ...item,
          file: {
            ...item.file,
            progress: data.percent,
            buffer: data.percent,
            visible: false,
            progress_message: data.progress_message,
          },
        };
      });
      const updated = {
        ...existing,
        [candidateId]: {
          data: checkData,
          status: "Inprogress",
        },
      };
      localStorage.setItem("Candidate Sourcing", JSON.stringify(updated));
      dispatch(
        JobCandidateSourcing({
          id: candidateId,
          data: updated[candidateId].data,
          status: data.percent === 100 ? "success" : "Inprogress",
        })
      );
    } else if (data && data?.length !== 0 && data[0]?.id) {
      // navigate(`/candidates/candidate-view?view-id=${candidateId}`);
      const existing =
        JSON.parse(localStorage.getItem("Candidate Sourcing")) || {};
      let checkData = existing[candidateId].data.map((item) => {
        return {
          ...item,
          file: {
            ...item.file,
            progress: 100,
            buffer: 100,
            visible: false,
          },
        };
      });
      const updated = {
        ...existing,
        [candidateId]: {
          data: checkData,
          status: "success",
        },
      };

      dispatch(
        JobCandidateSourcing({
          id: candidateId,
          data: updated[candidateId].data,
          status: "success",
        })
      );
      setCheckSelected((prev) => ({
        ...prev,
        candidateSelect: [],
        externalSelect: [],
      }));
      handleFetchCall(candidateId);

      handleFetchCall(candidateId, (data) => {
        if (data) {
          const filterData = data
            .filter((item) =>
              checkData.some((apiItem) => apiItem.id === item.id)
            )
            .map((item) => ({
              ...item,
              file: {
                progress: 100,
                buffer: 100,
                visible: false,
              },
              result_title: "Candidate Search Results",
            }));
          dispatch(
            JobCandidateSourcing({
              id: candidateId,
              data: filterData,
              status: "success",
            })
          );
        }
      });
    } else if (!success) {
      const existing =
        JSON.parse(localStorage.getItem("Candidate Sourcing")) || {};
      let checkData = existing[candidateId].data.map((item) => {
        return { ...item.file, visible: true, message: message };
      });
      const updated = {
        ...existing,
        [candidateId]: {
          data: checkData,
          status: "fail",
        },
      };

      localStorage.setItem("Candidate Sourcing", JSON.stringify(updated));
      dispatch(
        JobCandidateSourcing({
          id: candidateId,
          data: updated[candidateId].data,
          status: "fail",
        })
      );
    }
  };

  const handleBackClick = () => {
    navigate(`/candidates/candidate-view?view-id=${candidateId}`);
  };

  console.log(candidateSourcing, "candidateSourcing");

  // let candidateSourcing_demo = {
  //   data: [],
  //   status: "",
  //   "1afd2f0c-8ea5-46f2-b3e3-065e57a667cf": {
  //     data: [
  //       {
  //         client: "NeuralFlow Technologies Pvt. Ltd",
  //         id: "497019c6-b069-4f8d-83da-b2884a6ca506",
  //         order_no: 194,
  //         title: "Senior Cloud Infrastructure Engineer",
  //         relevancy_score: 80.53,
  //         status: "Active",
  //         match_criteria_normal: ["Title Match", "Skill Match"],
  //         match_criteria_deep: {
  //           skills: {
  //             total_skills: 5,
  //             matched_skills: 3,
  //           },
  //         },
  //         is_resume_added: false,
  //         result_title: "Candidate Search Results",
  //         file: {
  //           progress: 1,
  //           buffer: 1,
  //           visible: false,
  //         },
  //       },
  //     ],
  //     status: "Inprogress",
  //   },
  // };
  return (
    <CustomDiv
      margin={"1rem 1rem 1rem 1.5rem"}
      padding={"1rem"}
      borderRadius={"10px"}
      background="#fff"
      border={"1px solid rgba(0, 0, 0, 0.12)"}
    >
      {resultData.loading ? (
        <HandleSkeletion height={50} width={"60%"} />
      ) : (
        <Breadcrumbs breadCrumbData={breadCrumbData} />
      )}

      <CommonGrid2
        container
        spacing={2}
        alignItems="center"
        marginTop={"2rem"}
        justifyContent={"space-between"}
      >
        <CommonGrid2
          display={"flex"}
          flexDirection={"column"}
          gap={"8px"}
          size={12}
        >
          <CommonGrid2
            flexWrap={"wrap"}
            display={"flex"}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            {resultData.loading ? (
              <HandleSkeletion height={70} width={"45%"} />
            ) : (
              <CommonGrid2 display={"flex"} flexDirection={"column"} gap="5px">
                <Typography variant="h3" fontWeight={700}>
                  {query.get("name")}
                </Typography>
                <Typography variant="h6">{query.get("title")}</Typography>
              </CommonGrid2>
            )}
            {resultData.loading ? (
              <HandleSkeletion height={70} width={"45%"} />
            ) : (
              <CommonGrid2
                display={"flex"}
                justifyContent={"space-between"}
                gap={"1rem"}
              >
                <CommonButton
                  value={"Back"}
                  startIcon={<BackArrowIco />}
                  gap={"0px"}
                  variant="outlined"
                  color="#344054"
                  padding={"8px 1.5rem"}
                  fontWeight={"700"}
                  fontSize={"15px"}
                  border={"#D0D5DD"}
                  width="auto"
                  customStyle={{
                    "&:hover svg path": {
                      stroke: "#fff",
                    },
                  }}
                  onClick={handleBackClick}
                />

                <CommonButton
                  value={"Search Again"}
                  variant="outlined"
                  color="#344054"
                  padding={"8px 1.5rem"}
                  fontWeight={"600"}
                  fontSize={"15px"}
                  border={"#D0D5DD"}
                  disabled={
                    processConditionCheckInprogress || resultData.loading
                  }
                  loading={resultData.searhLoading}
                  onClick={handleSerchAgain}
                />
                <CommonButton
                  fontWeight="600"
                  startIcon={<AddIcon />}
                  gap={"0px"}
                  value={"Add Candidate to Job"}
                  padding={"8px 1.5rem"}
                  disabled={
                    processConditionCheckInprogress ||
                    resultData.loading ||
                    (checkSelected &&
                      checkSelected.candidateSelect.length === 0)
                  }
                  onClick={handleAddToJob}
                />
              </CommonGrid2>
            )}
          </CommonGrid2>
        </CommonGrid2>
      </CommonGrid2>
      {processConditionCheck && (
        <CandidateProgress
          checkSelected={candidateSourcing?.[candidateId]?.data}
          handleViewClick={handleViewClick}
        />
      )}       

      <CandidateResult
        resultData={resultData}
        handleHubTableBodyData={handleHubTableBodyData}
        handleDetails={handleDetails}
        checkSelected={checkSelected}
        processConditionCheck={
          candidateSourcing[candidateId] &&
          candidateSourcing[candidateId].data.length !== 0 &&
          candidateSourcing[candidateId].status === "fail"
            ? false
            : candidateSourcing[candidateId] &&
              candidateSourcing[candidateId].data.length !== 0 &&
              candidateSourcing[candidateId].status !== "process"
        }
        condition={false}
      />

      <SnackBar
        snackbarState={snackbarState}
        handleCloseValidation={handleCloseValidation}
      /> 
    </CustomDiv>
  );
}
